import { isEmpty, unset, get } from 'lodash';
import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';

import { IAuthenticationMeetingsValidationErrors } from '../authentication.interfaces';

import { ICommonKeyValues, ICommonResponseError } from '../../../../Common/@types/core';

@Injectable()
export class AuthenticationMeetingsErrorService {
	handleSuccessResponse (response: ICommonResponseError, validationsErrorObject: IAuthenticationMeetingsValidationErrors, control: AbstractControl): void {
		if (!isEmpty(response.Error) || !isEmpty(response.ErrorMessages)) {
			this.showCustomError(response, validationsErrorObject, control);
		}
	}

	showCustomError (response: ICommonKeyValues, validationsErrorObject: IAuthenticationMeetingsValidationErrors, control: AbstractControl) {
		validationsErrorObject.custom = get(response, 'ErrorMessages[0]') || response.Error;
		control.setErrors({CustomError: true});
	}

	onChangeFieldHandler (control: AbstractControl, resource: {validationCustomErrors: IAuthenticationMeetingsValidationErrors}) {
		if (resource.validationCustomErrors.custom) {
			control.setErrors(null);
			unset(resource, 'validationCustomErrors.custom');
		}
	}
}
